import { getMembersAdapter, GetMembersResult, getMemberAdapter, GetMemberResult } from 'application/adapters/members/membersAdapter';

export type Member = {
	memberId?: string;
	name: string;
	company: string;
	pNumber: string;
	branch: string;
	job?: string;
	birthday?: Date | null;
	employedOn?: Date | null;
	isHighlighted?: boolean;
	phones?: Array<string>;
	emails?: Array<string>;
	privateEmails?: Array<string>;
	privatePhones?: Array<string>;
	chairedTitles?: Array<{
		chairedTitle: string;
		actingMemberPeriod?: Date | null;
	}>;
	event?: {
		type: string;
		date: Date | null;
	};
	linkedAgreements?: Array<{
		id: string;
		name: string;
		url?: string;
	}>;
};
export const getMembers = async (hostname: string): Promise<Member[]> => {
	const members = await getMembersAdapter(hostname);
	return mapMembers(members);
};

export const mapMembers = (members: GetMembersResult): Member[] => {
	return members.map((member) => ({
		...member,
		name: member.name,
		company: member.company,
		branch: member.branch,
		pNumber: member.pNumber,
		birthday: new Date(member.birthday),
		employedOn: new Date(member.employedOn),
		isHighlighted: member.isHighlighted,
		chairedTitles:
			member.chairedTitles?.map((chairedTitle) => ({
				...chairedTitle,
				actingMemberPeriod: new Date(chairedTitle.actingMemberPeriod),
			})) ?? [],
		event: member.event
			? {
					...member.event,
					date: new Date(member.event.date),
			  }
			: undefined,
		linkedAgreements: member.linkedAgreements ?? [],
	}));
};

// Single member
export const getMember = async (hostname: string): Promise<Member> => {
	const member = await getMemberAdapter(hostname);
	return mapMember(member);
};

export const mapMember = (member: GetMemberResult): Member => {
	return {
		memberId: member.memberId,
		name: member.name,
		company: member.company,
		pNumber: member.pNumber,
		branch: member.branch,
		job: member.job,
		employedOn: new Date(member.employedOn),
		chairedTitles:
			member.chairedTitles?.map((chairedTitle) => ({
				...chairedTitle,
				actingMemberPeriod: new Date(chairedTitle.actingMemberPeriod),
			})) ?? [],
		event: member.event
			? {
					...member.event,
					date: new Date(member.event.date),
			  }
			: undefined,
		linkedAgreements: member.linkedAgreements ?? [],
	};
};
